import React from 'react';
import { Upload, message, Icon } from 'antd';
import styles from './uploadList.module.less';
import classnames from 'classnames';
import { downloadImg, uploadImg } from "@/utils/constant";
import $$ from "cmn-utils";

/**
 * 使Upload可以走全局代理，并可携带全局头部信息
 */
export default class UploadList extends React.Component {
    state = {
        imageList: [],
        loading: false,
    }
    componentDidMount() {
        this.setImageList();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)) {
            this.setImageList();
        }
    }

    setImageList = () => {
        const { value } = this.props;
        if (Array.isArray(value) && value.length > 0) {
            this.setState({ imageList: value });
        } else {
            this.setState({ imageList: [] });
        }
    }

    handleUpload(e, index) {
        let { imageList } = this.state;
        if (e && e.file) {
            let file = e.file;
            if (file && file.status === "done") {
                const response = file.response;
                if (response.code === "OK") {
                    if (index >= 0 && index < imageList.length) {
                        imageList[index] = response.body;
                    } else {
                        imageList.push(response.body);
                    }
                    this.setState({ imageList }, this.onChange);
                } else {
                    message.error(response.message);
                }
                this.setState({ loading: false });
            } else if (file && file.status === "uploading") {
                if (index >= imageList.length) {
                    this.setState({ loading: true });
                }
            }
        }
    }
    onChange = () => {
        const { imageList } = this.state;
        const { onChange } = this.props;
        onChange && onChange(imageList && imageList.length > 0 ? imageList : []);
    }
    render() {
        const { className } = this.props;
        const { imageList, loading } = this.state;
        let parameter = {
            className: styles.upload,
            data: { type: 'OTHER' },
            accept: 'image/*',
            action: uploadImg,
            listType: "picture-card",
            headers: $$.getStore("headers"),
            showUploadList: false,
            ...this.props,
        }
        return (
            <div className={classnames(styles.main, className)}>
                {imageList && imageList.length > 0 ?
                    imageList.map((item, index) => {
                        return (
                            <Upload
                                {...parameter}
                                onChange={e => this.handleUpload(e, index)}
                            >
                                <img
                                    className={styles.image}
                                    src={downloadImg + item}
                                    alt=""
                                />
                            </Upload>
                        )
                    })
                    : ``}
                <Upload
                    {...parameter}
                    onChange={e => this.handleUpload(e, imageList && imageList.length > 0 ? imageList.length : 0)}
                >
                    <div className={styles.iconDiv}>
                        <Icon className={styles.icon} type={loading ? 'loading' : 'plus'} />
                    </div>
                </Upload>
            </div>
        );
    }
}
